import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import LandingPage from "@/pages/LandingPage";
import ContactSalesPage from "@/pages/ContactSalesPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsPage from "@/pages/TermsPage";
import RefundPolicyPage from "@/pages/RefundPolicyPage";
import CookiePolicyPage from "@/pages/CookiePolicyPage";
import LegalPage from "@/pages/LegalPage";
import AboutUsPage from "@/pages/AboutUsPage";
import ContactUsPage from "@/pages/ContactUsPage";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ClinicsPage from "@/pages/admin/ClinicsPage";
import CreateClinicPage from "@/pages/admin/CreateClinicPage";
import ClinicDetailPage from "@/pages/admin/ClinicDetailPage";
import LeadsPage from "@/pages/admin/LeadsPage";
import AdminAnalyticsPage from "@/pages/admin/AdminAnalyticsPage";
import ManageSubscriptionsPage from "@/pages/admin/ManageSubscriptionsPage";

import DoctorLogin from "@/pages/doctor/DoctorLogin";
import DoctorDashboard from "@/pages/doctor/DoctorDashboard";
import PatientManagementPage from "@/pages/doctor/PatientManagementPage";
import DoctorPatientProfilePage from "@/pages/doctor/PatientProfilePage";
import StaffManagementPage from "@/pages/doctor/StaffManagementPage";
import ClinicSettingsPage from "@/pages/doctor/ClinicSettingsPage";
import AnalyticsPage from "@/pages/doctor/AnalyticsPage";
import QueuePage from "@/pages/doctor/QueuePage";
import ConsultationPage from "@/pages/doctor/ConsultationPage";
import PrescriptionPrintPage from "@/pages/doctor/PrescriptionPrintPage";
import PrescriptionEditPage from "@/pages/doctor/PrescriptionEditPage";

import StaffLogin from "@/pages/staff/StaffLogin";
import StaffDashboard from "@/pages/staff/StaffDashboard";
import NewAppointmentPage from "@/pages/staff/NewAppointmentPage";
import PatientSearchPage from "@/pages/staff/PatientSearchPage";
import StaffPatientProfilePage from "@/pages/staff/StaffPatientProfilePage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/contact-sales" element={<ContactSalesPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-and-conditions" element={<TermsPage />} />
          <Route path="/refund-policy" element={<RefundPolicyPage />} />
          <Route path="/cookie-policy" element={<CookiePolicyPage />} />
          <Route path="/legal" element={<LegalPage />} />
          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/contact-us" element={<ContactUsPage />} />

          <Route path="/ali-admin-portal/login" element={<AdminLogin />} />
          <Route path="/ali-admin-portal/dashboard" element={<ProtectedRoute role="SUPER_ADMIN"><AdminDashboard /></ProtectedRoute>} />
          <Route path="/ali-admin-portal/clinics" element={<ProtectedRoute role="SUPER_ADMIN"><ClinicsPage /></ProtectedRoute>} />
          <Route path="/ali-admin-portal/clinics/new" element={<ProtectedRoute role="SUPER_ADMIN"><CreateClinicPage /></ProtectedRoute>} />
          <Route path="/ali-admin-portal/clinics/:id" element={<ProtectedRoute role="SUPER_ADMIN"><ClinicDetailPage /></ProtectedRoute>} />
          <Route path="/ali-admin-portal/leads" element={<ProtectedRoute role="SUPER_ADMIN"><LeadsPage /></ProtectedRoute>} />
          <Route path="/ali-admin-portal/analytics" element={<ProtectedRoute role="SUPER_ADMIN"><AdminAnalyticsPage /></ProtectedRoute>} />
          <Route path="/ali-admin-portal/subscriptions" element={<ProtectedRoute role="SUPER_ADMIN"><ManageSubscriptionsPage /></ProtectedRoute>} />

          <Route path="/doctor/login" element={<DoctorLogin />} />
          <Route path="/doctor/dashboard" element={<ProtectedRoute role="DOCTOR"><DoctorDashboard /></ProtectedRoute>} />
          <Route path="/doctor/patients" element={<ProtectedRoute role="DOCTOR"><PatientManagementPage /></ProtectedRoute>} />
          <Route path="/doctor/patients/:patientId" element={<ProtectedRoute role="DOCTOR"><DoctorPatientProfilePage /></ProtectedRoute>} />
          <Route path="/doctor/patients/:patientId/consult/:appointmentId" element={<ProtectedRoute role="DOCTOR"><ConsultationPage /></ProtectedRoute>} />
          <Route path="/doctor/prescriptions/:prescriptionId/print" element={<ProtectedRoute role="DOCTOR"><PrescriptionPrintPage /></ProtectedRoute>} />
          <Route path="/doctor/prescriptions/:prescriptionId/edit" element={<ProtectedRoute role="DOCTOR"><PrescriptionEditPage /></ProtectedRoute>} />
          <Route path="/doctor/staff" element={<ProtectedRoute role="DOCTOR"><StaffManagementPage /></ProtectedRoute>} />
          <Route path="/doctor/settings" element={<ProtectedRoute role="DOCTOR"><ClinicSettingsPage /></ProtectedRoute>} />
          <Route path="/doctor/analytics" element={<ProtectedRoute role="DOCTOR"><AnalyticsPage /></ProtectedRoute>} />
          <Route path="/doctor/queue" element={<ProtectedRoute role="DOCTOR"><QueuePage /></ProtectedRoute>} />

          <Route path="/staff/login" element={<StaffLogin />} />
          <Route path="/staff/dashboard" element={<ProtectedRoute role="RECEPTIONIST"><StaffDashboard /></ProtectedRoute>} />
          <Route path="/staff/appointments/new" element={<ProtectedRoute role="RECEPTIONIST"><NewAppointmentPage /></ProtectedRoute>} />
          <Route path="/staff/search" element={<ProtectedRoute role="RECEPTIONIST"><PatientSearchPage /></ProtectedRoute>} />
          <Route path="/staff/patients/:patientId" element={<ProtectedRoute role="RECEPTIONIST"><StaffPatientProfilePage /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </AuthProvider>
  );
}

export default App;
